export function BrandLogo() {
  return <img alt="" src="/somnus.svg" />;
}
